export default function distinctiveRingtoneReducer(distinctiveRingtone, action) {
  switch (action.type) {
    case "set":
      return action.value;

    default:
      return { ...distinctiveRingtone, [action.type]: action.value };
  }
}
